define('views/layout/footer',['require','backbone','marionette','text!templates/layout/footer.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');

    var temp = require("text!templates/layout/footer.html");

    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'container-fluid container-fixed-lg footer',

        initialize: function(options) {

        }

    });
});
